import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Cta from "components/common/Cta";
import cx from "classnames";
import "../styles.sass";

type Props = {
  startSlug: string
  cta: any;
  className?: string
};

const WhyCharles = ({ className, cta, startSlug }: Props) => (
  <Container>
    <Row>
      <Col xs={12}>
        <div className={cx("charles-card treatments-charles-card", className)}>
          <div className="treatments-charles-card-text-wrapper">
            <div className="charles-card-top">
              Pourquoi faire confiance à Charles ?
            </div>
            <div className="charles-card-content">
              <span className="underline">
                Plus de 50 000 patients ont fait confiance à nos médecins
              </span>{" "}
              et à notre approche unique pour résoudre efficacement et
              durablement leurs problèmes chroniques de santé du quotidien
              directement depuis chez eux.
            </div>
          </div>
          {cta || (
            <Cta
              text="Consultez un médecin"
              path={startSlug}
              className="new-primary-cta"
            />
          )}
        </div>
      </Col>
    </Row>
  </Container>
);

export default WhyCharles